import { fetchItemCardModelsIfNeeded } from './itemCardModel';
import { fetchSellerEndedCatalogsIfNeeded } from './sellerEndedCatalogs';
import { fetchSellerPreviewCatalogsIfNeeded } from './sellerPreviewCatalogs';
import { fetchSellerRecordResultsIfNeeded, getSellerRecordResultsIds } from './sellerRecordResults';
import { fetchSellersDetailsIfNeeded } from './sellerDetail';
import { fetchSellersIfNeeded, getSeller } from './seller';
import { fetchSellerUpcomingCatalogsIfNeeded } from './sellerUpcomingCatalogs';
import { getNotFoundUrl } from '@/utils/urls';
import { push } from 'connected-react-router';

export const fetchDataForSellerPage = (sellerId: number) => async (dispatch: Function, getState: Function) => {
    return Promise.all([
        dispatch(fetchSellersIfNeeded([sellerId])),
        dispatch(fetchSellersDetailsIfNeeded([sellerId])),
        dispatch(fetchSellerPreviewCatalogsIfNeeded(sellerId)),
        // @ts-ignore
    ]).then(() => {
        const seller = getSeller(getState(), sellerId);
        if (!seller || !seller.sellerId) {
            return Promise.all([dispatch(push(getNotFoundUrl()))]);
        }
        return Promise.resolve();
    });
};

export const fetchDataForSellerPageUpcoming = (sellerId: number) => async (dispatch: Function) => {
    return Promise.all([dispatch(fetchSellerUpcomingCatalogsIfNeeded(sellerId))]);
};

export const fetchDataForSellerPagePast =
    (sellerId: number, page: number, count: number | 'all', searchTerms: string, sort: string) =>
    async (dispatch: Function) =>
        Promise.all([dispatch(fetchSellerEndedCatalogsIfNeeded(sellerId, page, count, sort))]);

export const fetchDataForSellerPageRecordResults =
    (sellerId: number) => async (dispatch: Function, getState: Function) => {
        return Promise.all([dispatch(fetchSellerRecordResultsIfNeeded(sellerId))]).then(() => {
            const itemIds = getSellerRecordResultsIds(getState(), sellerId);
            if (itemIds.length) {
                return dispatch(fetchItemCardModelsIfNeeded(itemIds, 'SELLER-PAGE-RECORD-RESULTS'));
            }
            return Promise.resolve();
        });
    };
